module.exports = __webpack_public_path__ + "static/media/icon-Elo.9e8c7766.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-Elo.svg
// module id = 2902
// module chunks = 0